
import BankLIcon from '../../Assets/images/BankLoanIcon.png';
import PersonalLicon from '../../Assets/images/PersonalLoanIcon.png';
import BuisnessLIcon from '../../Assets/images/BuisnessLoanIcon.png';
import { useNavigate } from 'react-router-dom';

const LoanTypes = () => {

  const loanType = [
    // <FaChartLine size={40} className="text-green-500" />use icon instead of image
    {
      id: 1,
      icon: <img src={PersonalLicon} alt="Logo" className="h-16 w-30" />,
      title: 'Personal UPAS/LC',
      text: 'Personal UPAS/LC provide borrowers with flexibility in how they use the funds.',
    },
    {
      id: 2,
      icon: <img src={BuisnessLIcon} alt="Logo" className="h-16 w-30" />,
      title: 'Business UPAS/LC',
      text: 'Business UPAS/LC Services provide financial assistance to businesses for various purposes.',
    },
    {
      id: 3,
      icon: <img src={BankLIcon} alt="Logo" className="h-16 w-30" />,
      title: 'Bank UPAS/LC',
      text: 'Auto UPAS/LC Services provide financing options for individuals businesses to purchase a vehicle.',
    },
  ];

  const navigate = useNavigate();
  const handleLoginClick = () => navigate('/login');
  return (
    <div
      id="loantype"
      className="w-full 2xl:py-20 md:py-10 py-8 px-2 md:px-16 bg-seviceBg"
    >
      <div className="container mx-auto 2xl:px-10 lg:px-0 px-4">
        <h2 className="md:text-3xl text-2xl  font-bold text-center text-dark-blue mb-12 heading ">
          Types of UPAS/LC
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {loanType.map(loanType => (
            <div
              key={loanType.id}
              className="bg-seviceBg p-6 rounded-3xl shadow-2xl hover:shadow-2xl hover:bg-gray-100 transition-shadow duration-300 border border-seviceBg"
            >
              <div className="flex items-center justify-center mb-4">
                {loanType.icon}
              </div>
              <div className="flex flex-col items-center justify-center ">
                <h3 className="lg:text-2xl text-xl font-semibold text-gray-800 mb-2 heading">
                  {loanType.title}
                </h3>
                <p className="text-gray-500 mb-4 text-center text-xs md:text-sm paragraph">
                  {loanType.text}
                </p>
                <button
                  onClick={handleLoginClick}
                  className=" border-2 border-headerBtn  text-headerBtn md:px-4 px-2 md:py-2 py-1 text-xs md:text-lg rounded-3xl hover:bg-headerBtn hover:text-white button-text"
                >
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="text-center mt-12">
          {!showMore ? (
            <button 
              onClick={handleViewMore} 
              className="bg-headerBtn border-none text-gray-100 mb-2 px-6 py-2 rounded-3xl hover:bg-btnHover hover:px-8 hover:py-2 "
            >
              View More
            </button>
          ) : (
            <button 
              onClick={handleCloseMore} 
              className="bg-red-500 text-white px-6 py-2 rounded-3xl hover:bg-red-600 hover:px-8 hover:py-2"
            >
              Close
            </button>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default LoanTypes;
